import React, { useEffect, useState } from 'react';
import { Button, Col, Form } from 'react-bootstrap';
import LinkButton from 'components/shared/button/LinkButton';
import classes from './ViewActions.module.scss';

import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import GNEModal from 'components/shared/modal/Modal';
import { renameUserView } from '../services/user-view.service';

import { setAllMView } from 'store/home/homeMyViewSlice';
import { CONFIGURE_VIEW } from 'constants/constants';
import { renameInsightView } from 'store/customer/customer-view-actions';
import { viewNameValidation } from 'utils/utils';
import {
  setAllInsightView,
  setSelectedInsightView,
} from 'store/customer/customerViewSlice';

const RenameViewModal = ({
  openModal,
  setOpenModal,
  currentViewRecord,
  page,
}) => {
  const dispatch = useDispatch();

  const [titleError, setTitleError] = useState('');
  const allMViews = useSelector((state) => state?.HomeMyView?.allMViews);
  const allInsightViews = useSelector(
    (state) => state?.CustomerView?.allInsightViews
  );
  const isMyview = page === CONFIGURE_VIEW.myView;

  const [title, setTitle] = useState(currentViewRecord?.name);

  const handleSubmit = async (event) => {
    event.preventDefault();
    event.stopPropagation();
    const form = event.currentTarget;

    if (form.checkValidity() === false) {
      if (title.trim().length === 0) {
        setTitleError('Please provide a title.');
      }
    } else {
      setTitle('');
      setTitleError('');
      setOpenModal((pre) => ({ ...pre, isRename: false }));
    }
    const payload = {
      id: currentViewRecord.Id,
      name: title,
    };

    if (isMyview) {
      await renameUserView(payload)
        .then(() => {
          const updatedViewRecord = allMViews.map((item) => {
            if (item.Id === currentViewRecord.Id) {
              return { ...item, name: title };
            }
            return item;
          });
          dispatch(setAllMView(updatedViewRecord));
          toast.success('Title of View changed successfully.');
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      await renameInsightView(payload)
        .then(() => {
          const updatedViewRecord = allInsightViews.map((item) => {
            if (item.Id === currentViewRecord.Id) {
              dispatch(setSelectedInsightView({ ...item, name: title }));
              return { ...item, name: title };
            }
            return item;
          });
          dispatch(setAllInsightView(updatedViewRecord));
          toast.success('Title of View changed successfully.');
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  const onCancel = (event) => {
    event?.preventDefault();

    setOpenModal((pre) => ({ ...pre, isRename: false }));
    setTitle(currentViewRecord?.name);
    setTitleError('');
  };

  const handleTitleChange = (e) => {
    const value = e.target.value;
    const view = viewNameValidation(value);
    setTitle(view?.name);
    setTitleError(view?.errMsg);
  };

  useEffect(() => {
    if (currentViewRecord?.name) {
      setTitle(currentViewRecord?.name);
      setTitleError('');
    }
  }, [currentViewRecord]);

  const content = (
    <>
      <p className='d-flex align-items-center gap-1 ms-3'>
        <i className='icon icon__configureEditInsightTitle lg me-1' />
        <span className='text text__text-medium text__bold'>Rename View Title</span>
      </p>
      <Form
        className='mx-3'
        noValidate
        onSubmit={handleSubmit}>
        <div>
          <Form.Group
            as={Col}
            controlId='validationCustom01'>
            <Form.Label className='text text__small'>Title</Form.Label>
            <Form.Control
              required
              type='text'
              value={title}
              onChange={handleTitleChange}
              autoComplete='off'
              isInvalid={titleError?.length > 0}
              isValid={title?.length > 0 && titleError?.length === 0}
              maxLength={129}
            />
            <Form.Control.Feedback
              className='animate__animated animate__pulse w-100'
              type='invalid'>
              <div className='d-flex justify-content-between'>
                <span>{titleError}</span> <span>{title?.length} / 128 </span>
              </div>
            </Form.Control.Feedback>
          </Form.Group>
          {!titleError && (
            <span className=' w-100 d-flex justify-content-end'>
              {title?.length} / 128
            </span>
          )}
        </div>
        <div className='d-flex justify-content-end mt-4 mb-2'>
          <LinkButton
            onClick={onCancel}
            className='text text__small  me-2'>
            Cancel
          </LinkButton>
          <Button
            variant='btn btn-gne btn-primary'
            type='submit'
            className={` ${classes['btn-add']}`}
            disabled={
              !title?.length ||
              titleError?.length > 0 ||
              currentViewRecord?.name === title
            }>
            Save
          </Button>
        </div>
      </Form>
    </>
  );

  return (
    <>
      {openModal && (
        <GNEModal
          show={openModal}
          onHide={onCancel}
          content={content}
          css='size-medium'
        />
      )}
    </>
  );
};

export default RenameViewModal;
